<script lang="ts">
    import AnimationControls from './AnimationControls.svelte';
    import DimensionsControls from './DimensionsControls.svelte';
    import RuleControls from './RuleControls.svelte';
    import ViewControls from './ViewControls.svelte';
</script>

<main>
    <h2>Controls</h2>
    <RuleControls />
    <DimensionsControls />
    <ViewControls />
    <AnimationControls />
</main>
